// eslint-disable-next-line no-empty-function
export const STUB_FUNCTION = () => {};
